document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('[data-description-accordion]');
  if (!accordions.length) return;

  const OPEN_DURATION = 900;   // slower open
  const CLOSE_DURATION = 600;  // slower close
  const EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

  const getPanel = (details) => details.querySelector('[data-description-accordion-panel]');

  const setIsOpenState = (details, isOpen) => {
    details.classList.toggle('is-open', isOpen);
    const summary = details.querySelector('[data-description-accordion-summary]');
    if (summary) summary.setAttribute('aria-expanded', String(isOpen));
  };

  const animateHeight = (panel, from, to, duration, done) => {
    panel.style.transition = 'none';
    panel.style.height = `${from}px`;
    panel.offsetHeight; // reflow
    panel.style.transition = `height ${duration}ms ${EASING}`;
    panel.style.height = `${to}px`;

    const onEnd = (e) => {
      if (e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', onEnd);
      panel.style.transition = '';
      done && done();
    };

    panel.addEventListener('transitionend', onEnd);
  };

  const openItem = (details) => {
    const panel = getPanel(details);
    if (!panel) return;

    if (details.dataset.animating === 'true') return;
    details.dataset.animating = 'true';

    details.setAttribute('open', '');
    setIsOpenState(details, true); // icon flips immediately

    // Always open from 0 for smoothness
    panel.style.height = '0px';
    const target = panel.scrollHeight;

    requestAnimationFrame(() => {
      animateHeight(panel, 0, target, OPEN_DURATION, () => {
        panel.style.height = 'auto';
        details.dataset.animating = 'false';
      });
    });
  };

  const closeItem = (details) => {
    const panel = getPanel(details);
    if (!panel) return;

    // If it's already closed, hard reset to be safe
    if (!details.hasAttribute('open') && !details.classList.contains('is-open')) {
      panel.style.height = '0px';
      details.dataset.animating = 'false';
      return;
    }

    // If mid-open animation, we still want to close it smoothly from current height
    details.dataset.animating = 'true';
    setIsOpenState(details, false); // icon flips immediately

    // Lock current height (whether auto or mid-transition)
    const currentHeight = panel.getBoundingClientRect().height;
    panel.style.transition = 'none';
    panel.style.height = `${currentHeight}px`;
    panel.offsetHeight;

    requestAnimationFrame(() => {
      animateHeight(panel, currentHeight, 0, CLOSE_DURATION, () => {
        details.removeAttribute('open');
        panel.style.height = '0px';
        details.dataset.animating = 'false';
      });
    });
  };

  accordions.forEach((accordion) => {
    const items = Array.from(accordion.querySelectorAll('[data-description-accordion-item]'));
    if (!items.length) return;

    // Determine initial open (Liquid sets Description open)
    const initiallyOpen = items.find(d => d.hasAttribute('open')) || items[0];
    accordion._openItem = initiallyOpen;

    // Ensure only one is open at init
    items.forEach((d) => {
      const panel = getPanel(d);
      if (!panel) return;

      const shouldBeOpen = d === initiallyOpen;

      if (shouldBeOpen) {
        d.setAttribute('open', '');
        setIsOpenState(d, true);
        panel.style.height = 'auto';

        // normalize to auto (but prevent any "0 height" flashes)
        const h = panel.scrollHeight;
        panel.style.height = `${h}px`;
        requestAnimationFrame(() => {
          if (d.classList.contains('is-open')) panel.style.height = 'auto';
        });
      } else {
        d.removeAttribute('open');
        setIsOpenState(d, false);
        panel.style.height = '0px';
        d.dataset.animating = 'false';
      }
    });

    accordion.addEventListener('click', (event) => {
      const summary = event.target.closest('[data-description-accordion-summary]');
      if (!summary || !accordion.contains(summary)) return;

      const details = summary.closest('[data-description-accordion-item]');
      if (!details) return;

      event.preventDefault();

      // Don't allow toggling the same item while it's animating
      if (details.dataset.animating === 'true') return;

      const isOpen = details.classList.contains('is-open');

      if (isOpen) {
        closeItem(details);
        if (accordion._openItem === details) accordion._openItem = null;
        return;
      }

      // Close whatever accordion thinks is open, plus any stray opens (bug-proof)
      items.forEach((d) => {
        if (d !== details && (d.classList.contains('is-open') || d.hasAttribute('open'))) {
          closeItem(d);
        }
      });

      openItem(details);
      accordion._openItem = details;
    });
  });
});